import { FC } from 'react';
import { useIntl } from 'react-intl';
import PruFilter, { PruFilterItemType } from 'src/app/common/components/PruTable/PruFilter';
import { KeyTaskListParam, PublishedStatusEnum, ValidStatusEnum } from '../../../../types/key-task-summarizer-type';
import { categories, getCategoryTranslationKey } from '../../../../utils/key-task-summarizer-utils';

type KeyTaskSummarizerFilterProps = {
  filterState: KeyTaskListParam;
  onChangeFilter: (filterState: KeyTaskListParam) => void;
  onSearch: () => void;
};

const KeyTaskSummarizerFilter: FC<KeyTaskSummarizerFilterProps> = ({ filterState, onChangeFilter, onSearch }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });

  return (
    <PruFilter
      title={Translation('KeyTaskSummerizer.filter_title')}
      itemDef={[
        {
          type: PruFilterItemType.FREE_TEXT,
          field: 'name',
          initialValue: filterState.name,
          displayName: Translation('component.formLabel.name'),
        },
        {
          type: PruFilterItemType.DROPDOWN,
          style: { width: 150 },
          field: 'publishedStatus',
          initialValue: filterState.publishedStatus,
          displayName: Translation('component.formLabel.publish-status'),
          choices: [
            { displayName: Translation('component.status.all'), value: PublishedStatusEnum.ALL },
            { displayName: Translation('component.status.published'), value: PublishedStatusEnum.PUBLISHED },
            { displayName: Translation('component.status.unpublished'), value: PublishedStatusEnum.UNPUBLISHED },
          ],
        },
        {
          type: PruFilterItemType.DATE_RANGE,
          fieldFrom: 'publishedStartDate',
          fieldTo: 'publishedEndDate',
          initialDateFrom: filterState.publishedStartDate,
          initialDateTo: filterState.publishedEndDate,
          displayName: Translation('component.formLabel.published-time'),
        },
        {
          type: PruFilterItemType.DROPDOWN,
          style: { width: 150 },
          field: 'validStatus',
          initialValue: filterState.validStatus,
          displayName: Translation('component.formLabel.valid-status'),
          choices: [
            { displayName: Translation('component.status.all'), value: ValidStatusEnum.ALL },
            { displayName: Translation('component.status.valid'), value: ValidStatusEnum.VALID },
            { displayName: Translation('component.status.invalid'), value: ValidStatusEnum.INVALID },
          ],
        },
        {
          type: PruFilterItemType.DROPDOWN,
          style: { width: 150 },
          field: 'category',
          initialValue: filterState.category,
          displayName: Translation('KeyTaskSummerizer.category'),
          choices: [
            { displayName: Translation('component.status.all'), value: '' },
            ...categories.map((category) => ({
              displayName: Translation(getCategoryTranslationKey(category)),
              value: category,
            })),
          ],
        },
      ]}
      onChangeFilter={(data) =>
        onChangeFilter({
          ...filterState,
          name: data.name,
          publishedStatus: data.publishedStatus,
          publishedStartDate: data.publishedStartDate,
          publishedEndDate: data.publishedEndDate,
          validStatus: data.validStatus,
          category: data.category,
          page: 1,
        })
      }
      fetchData={onSearch}
    />
  );
};

export default KeyTaskSummarizerFilter;
